import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

function GetUrlParam(paraName) {
  //截取token
  // return paraName.slice(paraName.indexOf("=")+1,paraName.indexOf("&"))
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] === paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}
// axios.defaults.baseURL = 'https://api-dev.lejian.net'
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (GetUrlParam("t")) {
      config.headers = {
        "Content-Type": "application/json",
        "access-token": "",
        token: GetUrlParam("t"),
        Authorization: ""
      };
    } else {
      config.headers = {
        "Content-Type": "application/json",
        "access-token": "",
        Authorization: ""
      };
    }

    let tokenId = localStorage.getItem("TOKEN");
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["access-token"] = accessToken;
    }
    if (tokenId) {
      config.headers["user-token"] = tokenId;
      // config.headers['Authorization'] = 'JWT ' + tokenId;
    }
    if (lang) {
      config.headers["Accept-Language"] = lang;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code == 11005) {
      Message({ message: response.data.message, type: "error" });
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = window.origin + "/#/";
    }
    // code码过期
    if (response.data.code == 10018) {
      Message({ message: response.data.message, type: "error" });
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = window.origin + "/#/";
    }

    if (response.data.code == 140044) {
      Message({
        message:
          "您已预约，请勿重复预约，如需修改预约，请前往个人中心待体检项进行修改",
        type: "error"
      });
    } else {
      if (
        response.data.success == false &&
        response.data.code == 11111 &&
        response.data.message == "没有需要填写问卷的体检订单，请体检后再填写哦~"
      ) {
      } else if (response.data.success == false) {
        Message({ message: response.data.message, type: "error" });
      }
    }

    return response;
  },
  error => {
    // Message({
    //   message: error.response.data.data.gender[0],
    //   type: "error",
    //   center: true,
    //   duration: 5000
    // });
    return Promise.reject(error);
  }
);

//get请求
export const GET = (url, param) => {
  if (param) {
    return axios.get(url, {
      params: param
    });
  } else {
    return axios.get(url);
  }
};
//post请求
export const POST = (url, param, config) => {
  if (config) {
    return axios.post(url, param, config);
  } else {
    return axios.post(url, param);
  }
};

export const PUT = (url, param) => {
  return axios.put(url, param);
};

export const DELETE = url => {
  return axios.delete(url);
};



// WEBPACK FOOTER //
// ./src/utils/http.js